export default __webpack_public_path__ + "static/media/insta.fd5bb2fa.svg";